/**
 * Move element inside an array, return a new array
 * @param array Array to rearrange
 * @param from Current index of the element
 * @param to Destination index of the element
 */

export const arrayMove = (array: any[], from: number, to: number): any[] => {
  const arr = array.slice()
  arr.splice(to < 0 ? arr.length + to : to, 0, arr.splice(from, 1)[0])
  return arr
}

export default arrayMove

const splicer = (array: any[], element: any, index: number) => {
  const nextArray = [...array]
  nextArray.splice(index * 2, 0, element)
  return nextArray
}

/**
 * Combine two arrays into one with their elements in alternating order:
 *
 * ['a', 'b'], [1, 2] => ['a', 1, 'b', 2]
 */
export const weave = (array1: any[], array2: any[]) => {
  return array1.reduce(splicer, array2.slice())
}
